// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3469":"da703d73","5086":"10c671fb"}[chunkId] + ".chunk.css";
};